import { Modal } from "antd";

export const showConfirm = ({
  title = null,
  content = "",
  okText = "OK",
  cancelText = "Cancel",
  hideCancel = false,
}) => {
  return new Promise((resolve) => {
    Modal.confirm({
      title,
      content,
      centered: true,
      icon: null,
      zIndex: 999999,
      getContainer: document.body,

      okText,
      cancelText,
      okCancel: !hideCancel,

      cancelButtonProps: hideCancel
        ? { style: { display: "none" } }
        : {},

      onOk: () => resolve(true),
      onCancel: () => resolve(false),
    });
  });
};